import { ERROR_VUE } from '@/defines/errors'
import {BASE_URL} from '@/defines/constants'

export default {
  methods: {
    mNotification(msg) {
      if (msg.error !== undefined) {
          msg.type = 'error'
          if ( msg.title === undefined ) {
            msg.title = 'Code ' + ( msg.error.response != undefined ? msg.error.response.status : msg.error.code || ERROR_VUE )
          }
      } else if(msg.warning !== undefined) {
          msg.type = 'warning'
          msg.title = msg.title === undefined? 'Warning!' : msg.title
          msg.message = msg.warning
          msg.dangerouslyUseHTMLString = true
      } else if(msg.info !== undefined) {
          msg.type = 'info'
          msg.message = msg.info
      } else if(msg.plain !== undefined) {
        msg.message = msg.plain
        msg.position = 'top-left'
      } else {
          msg.type = 'success'
          msg.title = msg.title === undefined? 'Success!' : msg.title
      }
      this.$notify(msg)
      this.$emit('onProcessing', false)
    },

    mHasSpecialTags(text) {
      let filter = false
      let banned = [
        /script/g,
        /html/g,
        /iframe/g,
      ]

      let searchStr = text.toLowerCase()
      for (let i=0; i< banned.length; i += 1) {
        if (searchStr.search(banned[i]) >= 0) {
          filter = true
          break
        }
      }

      return filter
    },

    mValidateText (rule, value, callback) {
      let errors = ''
      if (rule.required !== undefined) {
        if (value === '') {
          errors += 'Input cannot be empty. '
        }
      }

      if (rule.max !== undefined) {
        if (value.length > rule.max) {
          errors += 'Length should be less than ' + rule.max + '. '
        }
      }

      if (rule.allowspecial !== undefined) {
        if (!rule.allowspecial && this.mHasSpecialTags(value)) {
          errors += 'Script and HTML special characters are not allowed.'
        }
      }

      if (errors !== '') {
        callback(new Error(errors))
      } else {
        callback()
      }
    },

    mIsBrowserIE() {
      if (navigator !== undefined && navigator.userAgent !== undefined) {
        let uaString = navigator.userAgent
        var match = /\b(MSIE |Trident.*?rv:|Edge\/)(\d+)/.exec(uaString)
        return (match) ? true : false
      }
    },

    mThirdPartyCookiesEnabled(evt) {
      const originURL = window.location.origin
      const checkerURL = originURL + '/static/thirdpartycookie/'

      if (!document.querySelector('#checkframe')) {
        const frame = document.createElement('iframe')
        frame.setAttribute('id', 'checkframe')
        frame.src = checkerURL
        document.body.appendChild(frame)
        window.addEventListener('message', this.mThirdPartyCookiesEnabled, false)
      } else {
        if (evt && evt.origin === originURL) {
          if (evt.data === 'MM:3PCunsupported') {
            let browsers = [
              {name: 'Chrome', url: 'https://support.google.com/chrome/answer/95647?hl=en'},
              {name: 'Firefox', url: 'https://support.mozilla.org/en-US/kb/enable-and-disable-cookies-website-preferences'},
              {name: 'Safari for MacOS', url: 'https://support.apple.com/guide/safari/manage-cookies-and-website-data-sfri11471/12.0/mac/10.14'},
              {name: 'Safari for iOS (iPhone/iPad)', url: 'https://www.whatismybrowser.com/guides/how-to-enable-cookies/safari-iphone-ipod'},
              {name: 'Internet Explorer', url: 'https://support.microsoft.com/en-us/help/17442/windows-internet-explorer-delete-manage-cookies'},
            ]

            let ul = '<ul>'
            browsers.forEach((item) => {
              ul += '<li><a href="'+ item.url +'">'+ item.name +'</a></li>'
            })
            ul += '</ul>'

            this.mNotification({title: "Third Party Cookies Are Blocked",
            warning: "<p>Our app uses cookies to communicate data from the canvas website.</p><br><p>Please set your browser's cookie settings to allow third party cookies to save and read cookie data, or add our app's URL<br><br><span style='color: green'>" + BASE_URL + "</span><br>to your browser cookies' allowed sites.</p><div id='instructions'><br><h4>Enabling third-party cookies</h4><p>For more information, please follow the instructions for your browser:</p><br>"+ ul +"</div>"})
          }
        }
      }
    },

    mGetUrlVar(url) {
      var vars = {}
      var parts = url.replace('?','/').split('/')
      for(var i=2; i<parts.length; i++) {
          if(!isNaN(parts[i])){
            vars[parts[i-1]] = parts[i]
          }
      }
      return vars
    },
  },
}
  